import React from 'react';
import { Layout, Icon,Form ,Modal,Alert,Input,message,Button} from 'antd';

import createHistory from 'history/createHashHistory'//导入路由跳转历史

import HelpBar from './HelpBar';//页面右上部的帮助等部分
import Son from './Router';//主体显示内容
import Nav from './Nav';//主体导航
import $ from "jquery"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import Evn from "./../../../assets/PubJs/hcPub"//获取公共方法
import "./style.css"
const history = createHistory();
const { Header, Sider, Footer, Content } = Layout;//定义外层框架所用组件
const FormItem = Form.Item;
let _PasswordRevise = null;
class PasswordRevise extends React.Component {
  state = {
    confirmDirty: false,
    visible:sessionStorage.getItem('pwdInfo')=='false'
  };

  componentDidMount() {
    _PasswordRevise = this;
  }

  handleConfirmBlur = (e) => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('两次输入的密码不匹配！');
    } else {
      callback();
    }
  }

  validateToNextPassword = (rule, value, callback) => {
    let reg = /^\S*$/;
    let text='长度为8-16个字符，必须包含字母、数字、符号中至少2种，不包括空格！';
    if (reg.test(value) == false) {
      callback(text);
    } else {
      const form = this.props.form;
      if (value != undefined) {
        if(value.length!=0){
          let reg2=/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,16}$/;
          if (!reg2.test(value)) {
            callback(text);
          } else {
            callback();
          }
        }
      }
      if (value && this.state.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    }
  }

  //密码修改弹窗确定
  handleOk = (e) => {
    _PasswordRevise.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let postData = {
            passWord: _PasswordRevise.props.form.getFieldValue("username"),
            newPassWord: _PasswordRevise.props.form.getFieldValue("password"),
            CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
        }
        $.ajax({
            url: Hcurl + '/user/UpdatePassword',
            type: "post",
            data: postData,
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            success: function (data) {


              if(data.indexOf('false')>-1){
                message.warn(data.split('|')[1])
              }else{
                      message.success("密码修改成功");
                    sessionStorage.setItem('pwdInfo', 'true');
                    _PasswordRevise.setState({
                        confirmDirty: false,
                        visible:false
                    })
                    setTimeout(()=>{
                        history.push({ pathname: '/Login/LoginMain/LoginEntry'})
                    },800)
              }
                // if (data.Status == '400') {
                //     message.warn(data.Msg);
                // } else {
                //     message.success("密码修改成功");
                //     sessionStorage.setItem('pwdInfo', 'true');
                //     _PasswordRevise.setState({
                //         confirmDirty: false,
                //         visible:false
                //     })
                //     setTimeout(()=>{
                //         history.push({ pathname: '/Login/LoginMain/LoginEntry'})
                //     },800)
                // }
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
        // const data = http.ajax({
        //   url: 'ComHomePage/UpdateComPassword',
        //   data: postData,
        //   type: 'post'
        // })
        
      }
    })
  }
  //密码修改弹窗取消
  handleCancel = (e) => {
    _PasswordRevise.setState({
      confirmDirty: false,
    })
    this.setState({
      visible: false,
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    return (
      <Modal
        title="密码修改"
        visible={this.state.visible}
        maskClosable={false}
        closable={false}
        width="600px"
        footer={[
          <Button key="submit" type="primary" onClick={this.handleOk}>
            确定
          </Button>,
        ]}
      >
        <Alert
          message="检测到您之前设置的密码较为简单，请按要求重新修改密码。" type="warning"
          showIcon
          style={{ marginBottom: '24px' }}
        />
        <Form style={{ width: 500, margin: "0 auto" }}>
          <FormItem
            {...formItemLayout}
            label="原密码"
          >
            {getFieldDecorator('username', {
              rules: [{
                required: true, message: '请输入原密码！',
              }, {
                validator: this.userTest,
              }],
            })(
              <Input type="password" placeholder="请输入原密码" />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="新密码"
          >
            {getFieldDecorator('password', {
              rules: [{
                required: true, message: '请输入密码！',
              }, { validator: this.validateToNextPassword }],
            })(
              <Input type="password" placeholder="8-16位，须同时包含字母、数字、符号，区分大小写" maxLength={16} />
            )}
          </FormItem>
          <FormItem
            {...formItemLayout}
            label="确认密码"
          >
            {getFieldDecorator('confirm', {
              rules: [{
                required: true, message: '请确认密码！',
              }, {
                validator: this.compareToFirstPassword,
              }],
            })(
              <Input type="password" onBlur={this.handleConfirmBlur} placeholder="确认密码" maxLength={16} />
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
const PasswordModal = Form.create()(PasswordRevise);
//外部布局
class App extends React.Component {

    //初始状态
    state = {
        collapsed: false,
        hei: 400,
        info: "",
        info2: ""
    };

    //菜单栏变化
    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    //屏幕尺寸变化
    windowChangeSize() {
        let H = window.innerHeight - 80;
        let W = window.innerWidth;
        let _this = this;
        if (W <= 960) {
            _this.setState({
                collapsed: true
            })
        } else {
            _this.setState({
                collapsed: false
            })
        }
        this.setState({
            hei: H > 580 ? H : 580
        })
    }
    getCom_Name = () => {  //获取先行和解默认企业信息
        $.ajax({
            url: Hcurl + "/CompanyCore/GetXXHJCompanyDefultName?u_code=" + Evn.getUserInfo().CU_Code,
            type: 'post',
            success: function (data) {
                console.log(data, 'success');
                if (data == '' || data == null) {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = null;
                    userInfo.XXHJCom_Name = null;
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                } else {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.xxhjcompanycode = data.split("|")[1];
                    userInfo.XXHJCom_Name = data.split("|")[2];
                    localStorage.setItem("userInfo", JSON.stringify(userInfo));
                }

                //history.push({
                //    pathname: "/Content/Business/CompanyList/test",
                //})
            },
            error: function (data) {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                console.log(data, 'error')
            }

        })
    }
    getDefaultCom() {
        let setData = {
            UserCode: Evn.getUserInfo().CU_Code,
        };
        $.ajax({
            url: Hcurl + "/CompanyCore/GetCompanyInfo",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": Evn.getUserInfo().token
            },
            success: function (res) {
                if (res.split("|")[0] === "false") {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.UCR_ComID = null;
                    userInfo.Com_Name = null;
                    userInfo.UCR_IsAdmin = null;
                    localStorage.setItem("userInfo", JSON.stringify(userInfo))
                } else {
                    let userInfo = JSON.parse(localStorage.userInfo);
                    userInfo.UCR_ComID = res.split("|")[1];
                    userInfo.Com_Name = res.split("|")[2];
                    userInfo.UCR_IsAdmin = res.split("|")[3];
                    localStorage.setItem("userInfo", JSON.stringify(userInfo))
                }
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    componentWillMount() {
        this.getDefaultCom();
        this.getCom_Name();
    }

    getUser() {
        let _this = this;
        $.ajax({
            url: Hcurl + "/user/GetUserInfo",
            type: "post",
            data: {
                CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
            },
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            async: false,
            success: function (res) {
                //密码和手机号
                console.log(JSON.parse(res),"ddddddddddddddd")
                _this.setState({
                    info: JSON.parse(localStorage.getItem("userInfo")),
                    info2: JSON.parse(res)
                })
            },
            error: function (res) {
                history.push({ pathname: '/Login/LoginMain/LoginEntry', })
            }
        })
    }

    //组件加载完成后
    componentDidMount() {
        let _this = this;
        this.windowChangeSize()
        window.onresize = function () {
            _this.windowChangeSize()
        }
        this.getUser()
    }

    //组件的渲染
    render() {
        return (
            <Layout>
                <Header className="C_header">
                    <div className="logo"></div>
                    <div className="HomeTitle">
                        <span>江苏省“智慧315”综合服务平台</span>
                    </div>
                    <div className="HomeAction">
                        <HelpBar />
                    </div>
                </Header>
                <Layout>
                    <PasswordModal />
                    <Sider
                        trigger={null}
                        collapsible
                        collapsed={this.state.collapsed}
                        width={220}
                    >
                        <div style={{ display: this.state.collapsed ? "none" : "block" }} className="UserInfo">
                            <p className="UserName">
                                <span>{this.state.info2.userName||this.state.info2.loginName}</span>
                                你好！
                            </p>
                            <p style={{ padding: "0 12px",wordBreak:'break-all' }} className={"UserDep"}>{(this.state.info2.CU_Title == "" || this.state.info2.CU_Title == null) ? "您暂未设置称谓" : this.state.info2.CU_Title}</p>
                            <p className={"UserLasrLoginTime"}>上次登录：{(this.state.info.LastLoginTime == "" || this.state.info.LastLoginTime == null) ? "暂无登录记录" : this.state.info.LastLoginTime}</p>
                        </div>
                        <Nav coll={this.state.collapsed} />
                        <Icon
                            className="trigger"
                            type={this.state.collapsed ? 'menu-unfold' : 'menu-fold'}
                            onClick={this.toggle}
                        />
                    </Sider>
                    <Content className="HomeContent" style={{ minHeight: this.state.hei }}>
                        <Son />
                        <Footer className="HomeFoot">
                            技术支持：江苏户传科技有限公司   联系电话：025-83720315
                        </Footer>
                    </Content>
                </Layout>
            </Layout>
        );
    }
}

export default App




// WEBPACK FOOTER //
// ./src/components/Content/Wrap/Warp.js